<template>
  <div class="row">
    <div class="col">
      <div class="card card-modern">
        <div class="card-header">
          <div class="card-actions">
            <a
              class="card-action card-action-toggle"
              href="#revenue-collapse"
              data-bs-toggle="collapse"
            />
          </div>
          <h2 class="card-title">Dobit</h2>
        </div>
        <div class="card-body show" id="revenue-collapse">
          <div class="row">
            <div class="col-auto">
              <strong class="text-color-dark text-6">{{ dashboardData.revenue.thisMonthRevenue | money2 }}</strong>
              <h3 class="text-4 mt-0 mb-2">Ovaj mjesec</h3>
            </div>
            <div class="col-auto">
              <strong class="text-color-dark text-6">{{ dashboardData.revenue.lastMonthRevenue | money2 }}</strong>
              <h3 class="text-4 mt-0 mb-2">Prethodni mjesec</h3>
            </div>
            <div class="col-auto">
              <strong class="text-color-dark text-6">{{ dashboardData.revenue.totalRevenue | money2 }}</strong>
              <h3 class="text-4 mt-0 mb-2">Ukupna dobit</h3>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <!-- Morris: Area -->
              <div class="chart chart-md chart-bar-stacked-sm my-3" id="revenueChart" style="
                          height: 409px;
                          position: relative;
                          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                        ">
                <svg height="409" version="1.1" width="554" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" style="
                            overflow: hidden;
                            position: relative;
                            left: -0.984375px;
                            top: -0.078125px;
                          ">
                  <desc style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0)">
                    Created with Raphaël 2.3.0
                  </desc>
                  <defs style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0)"></defs>
                  <text x="32.53125" y="370" text-anchor="end" font-family="sans-serif" font-size="12px" stroke="none"
                    fill="#888888" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              text-anchor: end;
                              font-family: sans-serif;
                              font-size: 12px;
                              font-weight: normal;
                            " font-weight="normal">
                    <tspan dy="4.25" style="
                                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              ">
                      0
                    </tspan>
                  </text>
                  <text x="32.53125" y="283.75" text-anchor="end" font-family="sans-serif" font-size="12px" stroke="none"
                    fill="#888888" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              text-anchor: end;
                              font-family: sans-serif;
                              font-size: 12px;
                              font-weight: normal;
                            " font-weight="normal">
                    <tspan dy="4.25" style="
                                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              ">
                      50
                    </tspan>
                  </text>
                  <text x="32.53125" y="197.5" text-anchor="end" font-family="sans-serif" font-size="12px" stroke="none"
                    fill="#888888" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              text-anchor: end;
                              font-family: sans-serif;
                              font-size: 12px;
                              font-weight: normal;
                            " font-weight="normal">
                    <tspan dy="4.25" style="
                                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              ">
                      100
                    </tspan>
                  </text>
                  <text x="32.53125" y="111.25" text-anchor="end" font-family="sans-serif" font-size="12px" stroke="none"
                    fill="#888888" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              text-anchor: end;
                              font-family: sans-serif;
                              font-size: 12px;
                              font-weight: normal;
                            " font-weight="normal">
                    <tspan dy="4.25" style="
                                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              ">
                      150
                    </tspan>
                  </text>
                  <text x="32.53125" y="25" text-anchor="end" font-family="sans-serif" font-size="12px" stroke="none"
                    fill="#888888" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              text-anchor: end;
                              font-family: sans-serif;
                              font-size: 12px;
                              font-weight: normal;
                            " font-weight="normal">
                    <tspan dy="4.25" style="
                                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              ">
                      200
                    </tspan>
                  </text>
                  <text x="508.8193020833334" y="382.5" text-anchor="middle" font-family="sans-serif" font-size="12px"
                    stroke="none" fill="#888888" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              text-anchor: middle;
                              font-family: sans-serif;
                              font-size: 12px;
                              font-weight: normal;
                            " font-weight="normal" transform="matrix(1,0,0,1,0,7)">
                    <tspan dy="4.25" style="
                                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              ">
                      Dec
                    </tspan>
                  </text>
                  <text x="428.1605104166667" y="382.5" text-anchor="middle" font-family="sans-serif" font-size="12px"
                    stroke="none" fill="#888888" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              text-anchor: middle;
                              font-family: sans-serif;
                              font-size: 12px;
                              font-weight: normal;
                            " font-weight="normal" transform="matrix(1,0,0,1,0,7)">
                    <tspan dy="4.25" style="
                                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              ">
                      Oct
                    </tspan>
                  </text>
                  <text x="347.50171875" y="382.5" text-anchor="middle" font-family="sans-serif" font-size="12px"
                    stroke="none" fill="#888888" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              text-anchor: middle;
                              font-family: sans-serif;
                              font-size: 12px;
                              font-weight: normal;
                            " font-weight="normal" transform="matrix(1,0,0,1,0,7)">
                    <tspan dy="4.234375" style="
                                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              ">
                      Aug
                    </tspan>
                  </text>
                  <text x="266.8429270833334" y="382.5" text-anchor="middle" font-family="sans-serif" font-size="12px"
                    stroke="none" fill="#888888" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              text-anchor: middle;
                              font-family: sans-serif;
                              font-size: 12px;
                              font-weight: normal;
                            " font-weight="normal" transform="matrix(1,0,0,1,0,7)">
                    <tspan dy="4.25" style="
                                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              ">
                      Jun
                    </tspan>
                  </text>
                  <text x="186.1841354166667" y="382.5" text-anchor="middle" font-family="sans-serif" font-size="12px"
                    stroke="none" fill="#888888" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              text-anchor: middle;
                              font-family: sans-serif;
                              font-size: 12px;
                              font-weight: normal;
                            " font-weight="normal" transform="matrix(1,0,0,1,0,7)">
                    <tspan dy="4.25" style="
                                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              ">
                      Apr
                    </tspan>
                  </text>
                  <text x="105.52534375000002" y="382.5" text-anchor="middle" font-family="sans-serif" font-size="12px"
                    stroke="none" fill="#888888" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              text-anchor: middle;
                              font-family: sans-serif;
                              font-size: 12px;
                              font-weight: normal;
                            " font-weight="normal" transform="matrix(1,0,0,1,0,7)">
                    <tspan dy="4.25" style="
                                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              ">
                      Feb
                    </tspan>
                  </text>
                  <rect x="50.07242447916667" y="273.4" width="30.247046875000002" height="96.60000000000002" rx="0"
                    ry="0" fill="#0088cc" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="50.07242447916667" y="161.27499999999998" width="30.247046875000002" height="112.125" rx="0"
                    ry="0" fill="#2baab1" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="90.4018203125" y="238.9" width="30.247046875000002" height="131.1" rx="0" ry="0" fill="#0088cc"
                    stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="90.4018203125" y="73.29999999999998" width="30.247046875000002" height="165.60000000000002"
                    rx="0" ry="0" fill="#2baab1" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="130.73121614583334" y="257.875" width="30.247046875000002" height="112.125" rx="0" ry="0"
                    fill="#0088cc" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="130.73121614583334" y="128.5" width="30.247046875000002" height="129.375" rx="0" ry="0"
                    fill="#2baab1" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="171.06061197916668" y="232" width="30.247046875000002" height="138" rx="0" ry="0"
                    fill="#0088cc" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="171.06061197916668" y="76.75" width="30.247046875000002" height="155.25" rx="0" ry="0"
                    fill="#2baab1" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="211.39000781250002" y="275.125" width="30.247046875000002" height="94.875" rx="0" ry="0"
                    fill="#0088cc" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="211.39000781250002" y="180.25" width="30.247046875000002" height="94.875" rx="0" ry="0"
                    fill="#2baab1" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="251.71940364583335" y="240.625" width="30.247046875000002" height="129.375" rx="0" ry="0"
                    fill="#0088cc" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="251.71940364583335" y="214.75" width="30.247046875000002" height="25.875" rx="0" ry="0"
                    fill="#2baab1" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="292.0487994791667" y="233.725" width="30.247046875000002" height="136.275" rx="0" ry="0"
                    fill="#0088cc" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="292.0487994791667" y="87.1" width="30.247046875000002" height="146.625" rx="0" ry="0"
                    fill="#2baab1" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="332.3781953125" y="276.85" width="30.247046875000002" height="93.14999999999998" rx="0" ry="0"
                    fill="#0088cc" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="332.3781953125" y="168.175" width="30.247046875000002" height="108.67500000000001" rx="0"
                    ry="0" fill="#2baab1" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="372.70759114583336" y="235.45" width="30.247046875000002" height="134.55" rx="0" ry="0"
                    fill="#0088cc" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="372.70759114583336" y="66.39999999999998" width="30.247046875000002" height="169.05" rx="0"
                    ry="0" fill="#2baab1" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="413.0369869791667" y="309.625" width="30.247046875000002" height="60.375" rx="0" ry="0"
                    fill="#0088cc" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="413.0369869791667" y="230.27499999999998" width="30.247046875000002" height="79.35000000000002"
                    rx="0" ry="0" fill="#2baab1" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="453.36638281250004" y="309.625" width="30.247046875000002" height="60.375" rx="0" ry="0"
                    fill="#0088cc" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="453.36638281250004" y="237.175" width="30.247046875000002" height="72.44999999999999" rx="0"
                    ry="0" fill="#2baab1" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="493.69577864583334" y="245.8" width="30.247046875000002" height="124.19999999999999" rx="0"
                    ry="0" fill="#0088cc" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                  <rect x="493.69577864583334" y="106.07500000000002" width="30.247046875000002" height="139.725" rx="0"
                    ry="0" fill="#2baab1" stroke="none" fill-opacity="1" style="
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                              fill-opacity: 1;
                            "></rect>
                </svg>
                <div class="morris-hover morris-default-style" style="display: none"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Revenue',
  computed: {
    dashboardData() {
      return this.$store.getters.getDashboardData;
    },
  },
};
</script>